var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesktopDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 81,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.959 77.565c0 1.81-14.66 3.276-32.74 3.276-18.082 0-32.74-1.466-32.74-3.276 0-1.81 14.658-3.277 32.74-3.277 18.08 0 32.74 1.467 32.74 3.277",
    fill: "#10C98F",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.815 48.73l-.008-41.943a5.24 5.24 0 00-5.239-5.241H6.86a5.239 5.239 0 00-5.236 5.24L1.63 48.73h81.184z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1 48.73L59.241 1.546H6.86a5.239 5.239 0 00-5.236 5.24L1.63 48.73h10.468zM82.807 48.73v10.485a5.24 5.24 0 01-5.24 5.243H6.858a5.24 5.24 0 01-5.236-5.243V48.73h81.184z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.807 48.73v10.485a5.24 5.24 0 01-5.24 5.243H6.858a5.24 5.24 0 01-5.236-5.243V48.73h81.184z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.838 56.593a2.619 2.619 0 11-5.238 0 2.62 2.62 0 115.238 0",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.838 56.593a2.619 2.619 0 11-5.238 0 2.62 2.62 0 115.238 0z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M55.315 74.943H29.123l1.31-10.486h23.572z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M55.315 74.943H29.123l1.31-10.486h23.572zM21.267 74.943H63.17M82.815 48.73l-.008-41.943a5.24 5.24 0 00-5.239-5.241H6.86a5.239 5.239 0 00-5.236 5.24L1.63 48.73h81.184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.162 11.992c-7.106 0-12.866 5.766-12.866 12.877 0 3.555 1.44 6.776 3.767 9.104l18.195-18.21a12.817 12.817 0 00-9.096-3.77",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.027 24.87c0 7.11-5.76 12.876-12.865 12.876-7.107 0-12.866-5.766-12.866-12.877 0-7.111 5.76-12.877 12.866-12.877 7.104 0 12.865 5.766 12.865 12.877z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.162 31.308v1.61M42.162 16.821v1.61M38.945 28.088a3.217 3.217 0 106.433 0 3.218 3.218 0 00-3.217-3.219 3.217 3.217 0 01-3.216-3.219 3.217 3.217 0 116.433 0",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconDesktopDollar;